import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {StaticMethods} from '../../../model/GeneralModels';
import {Overlay, Map} from 'ol';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Vector} from 'ol/layer';
import {OpenRouteService} from '../../../services/open-route.service';
import Feature from 'ol/Feature';
import CircleStyle from 'ol/style/Circle';
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector';
import Geometry from 'ol/geom/Geometry';
import VectorLayer from 'ol/layer/Vector';
import {MatDialog} from '@angular/material/dialog';
import Point from 'ol/geom/Point';
import {LineString} from 'ol/geom';
import Polyline from 'ol/format/Polyline';
import {Coordinate} from 'ol/coordinate';
import {fromLonLat, toLonLat} from 'ol/proj';

declare var ol: any;
declare var $: any;

export interface HasElementRef {
  _elementRef: ElementRef;
}

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  styles: [`
    .map {
      width: 100%;
      height: 100%;
    }
  `]
})
export class MapComponent implements OnInit, OnChanges {
  @Output() locationChanged = new EventEmitter<number[]>();
  @Input() locations: any[];
  @Output() showNavigation = new EventEmitter();
  @Output() clearLocations = new EventEmitter();
  latitude: number;
  longitude: number;
  myLocation: Feature;
  customLocation: Feature;
  currentLocationPin: Vector;
  customLocationPin: Vector;
  selectedRoute: Feature = null;
  popup: Overlay;
  map: Map;
  private attribution: any;
  marker: any;
  private markStyles: MarksStyles;
  private movement: MovementMethods;
  selectedFeature: Feature = null;
  routesVector: Vector;

  constructor(public settings: AppSettingsService,
              private service: OpenRouteService,
              private matDialog: MatDialog) {
    StaticMethods.loadScript('https://openlayers.org/en/v4.6.5/build/ol.js');
    this.movement = new MovementMethods();
    this.markStyles = new MarksStyles();
  }

  ngOnInit() {
    this.initializeMap();
  }

  initializeMap() {
    this.attribution = new ol.control.Attribution({
      collapsible: false
    });
    this.map = new ol.Map({
      controls: ol.control.defaults({attribution: false}).extend([
        this.attribution
      ]),
      layers: [
        new ol.layer.Tile({
          source: new ol.source.OSM()
        })
      ],
      target: 'map',
      view: new ol.View()
    });
    this.map.getView().setZoom(10);
    this.map.getView().setCenter(ol.proj.fromLonLat([51.3890, 35.6892]));
    this.map.getView().setMaxZoom(17);
    this.latitude = 35.6892;
    this.longitude = 51.3890;
    // this.initializeMyLocation(this.longitude, this.latitude);
    this.marker = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [],
      })
    });
    this.routesVector = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [],
      })
    });
    this.setMarkerListener();
    // const geolocation = new ol.Geolocation();
    // geolocation.setTracking(true); // here the browser may ask for confirmation
    // geolocation.on('change:position', () => {
    //   console.log(geolocation.getPosition());
    // });
    // this.addRoute();
  }

  goToCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.setCurrentLocation(position.coords.latitude, position.coords.longitude);
        } else {
          console.log('not position');
        }
      }, (err) => {
        StaticMethods.showMessage(
          // tslint:disable-next-line:max-line-length
          'سرویس موقعیت خودم در دسترسی نمی باشد لظفا موقعیت را با (فشار و نگه داشتن اگر با گوشی هستید یا کلیک کردن اگر با کامپیوتر هستید) روی نقشه انتخاب نمایید'
        );
        throw err;
      }, {enableHighAccuracy: true, maximumAge: 300000, timeout: 5000});
    } else {
      console.log('not geolocation');
    }
  }

  onLocationChanged() {
    this.locationChanged.emit([this.latitude, this.longitude]);
  }

  setCurrentLocation(latitude: number, longitude: number) {
    this.longitude = longitude;
    this.latitude = latitude;
    this.map.removeLayer(this.currentLocationPin);
    this.myLocation = new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat([longitude, latitude])),
      name: 'current_location'
    });
    this.currentLocationPin = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [
          this.myLocation
        ]
      }),
      style: [
        this.markStyles.myLocationStyle
      ]
    });
    this.map.addLayer(this.currentLocationPin);
    this.clearLocations.emit();
    this.popup.getElement().style.display = 'none';
    this.map.removeLayer(this.routesVector);
    this.movement.moveAround(this.map, ol.proj.fromLonLat([longitude, latitude]), 'zoom', () => {
    });
    this.onLocationChanged();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.locations.firstChange) {
      if (changes.locations.previousValue !== changes.locations.currentValue) {
        this.updateLocations();
      }
    }
  }

  initializeMyLocation(longitude, latitude) {
    this.map.removeLayer(this.currentLocationPin);
    this.myLocation = new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat([longitude, latitude])),
      name: 'current_location'
    });
    this.customLocation = new ol.Feature({
      name: 'custom_location'
    });
    this.currentLocationPin = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [
          this.myLocation
        ]
      }),
      style: [
        this.markStyles.myLocationStyle
      ]
    });
    this.customLocationPin = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [
          this.customLocation
        ]
      }),
      style: [
        this.markStyles.pointStyle
      ]
    });
    this.map.addLayer(this.currentLocationPin);
    this.map.addLayer(this.customLocationPin);
    this.movement.moveAround(this.map, ol.proj.fromLonLat([longitude, latitude]), 'zoom', () => {
      this.onLocationChanged();
    });
    // this.addRoute();
  }

  setSelectedRoute(route: Feature, features: Feature[]) {
    features.forEach(feature => {
      feature.setStyle(this.getRouteStyle(route.getProperties().mode, false));
    });
    this.selectedRoute = route;
    this.selectedRoute.setStyle(this.getRouteStyle(route.getProperties().mode, true));
    const element = this.popup.getElement();
    this.popup.setPosition(fromLonLat(route.getProperties().middlePoint));
    element.innerHTML = `<span>${route.getProperties().distance}کیلومتر</span>`;
    element.style.display = 'block';
  }

  //

  private setMarkerListener() {
    // Popup showing the position the user clicked
    this.popup = new ol.Overlay({
      element: document.getElementById('custom-popup')
    });
    this.map.addOverlay(this.popup);


    this.map.on('click', (e) => {
      let selectedPixel = null;
      this.selectedFeature = null;
      this.map.forEachFeatureAtPixel(e.pixel, (feature, layer) => {
        selectedPixel = feature;
      });
      if (selectedPixel) {
        this.selectedFeature = selectedPixel;
        const type = this.selectedFeature.getGeometry().getType();
        const coordinate = this.getCoordinates(this.selectedFeature);
        switch (type) {
          case 'Point':
            this.movement.moveAround(this.map, coordinate, 'zoom', () => {
              // element.style.display = 'block';
              this.showNavigation.emit(this.selectedFeature);
            });
            break;
          case 'LineString':
            const source = this.routesVector.getSource();
            const features = source.getFeatures();
            this.setSelectedRoute(this.selectedFeature, features);
            break;
        }
      } else {
        const location = ol.proj.transform(e.coordinate, 'EPSG:3857', 'EPSG:4326');
        if (this.myLocation) {
          StaticMethods.openDialog(this.matDialog, 'آیا می خواهید موقعیت خودتان را اینجا تنظسم کنید؟', (result) => {
            if (result) {
              this.setCurrentLocation(location[1], location[0]);
            }
          }, '250px');
        } else {
          this.setCurrentLocation(location[1], location[0]);
        }
      }
    });
    this.zoomToExtent(this.currentLocationPin);
  }

  getCoordinates(feature: Feature): Coordinate[] {
    let geometry;
    switch (feature.getGeometry().getType()) {
      case 'Point':
        geometry = feature.getGeometry() as Point;
        break;
      case 'LineString':
        geometry = feature.getGeometry() as LineString;
        break;
      default:
        throw new Error('not coordinates detected');
    }
    return geometry.getCoordinates();
  }

  updateLocations() {
    this.map.removeLayer(this.marker);
    this.map.removeLayer(this.routesVector);
    this.popup.getElement().style.display = 'none';
    this.marker = new ol.layer.Vector();
    const features = [];
    this.locations.forEach(location => {
      const lonLat = ol.proj.fromLonLat([location.longitude, location.latitude]);
      const index = features.length;
      features[index] = new ol.Feature({
        geometry: new ol.geom.Point(lonLat),
        name: location.name,
        type: location.type,
        telephone: location.telephone,
        address: location.address,
        onlineLetter: location.onlineLetter ? StaticMethods.getTranslation('exists') : StaticMethods.getTranslation('notExists')
      });
    });
    this.marker = new ol.layer.Vector({
      source: new ol.source.Vector({
        features,
      }),
      style: [this.markStyles.randomLocationStyle]
    });
    this.map.addLayer(this.marker);
    // this.map.getView().fit(extent, {size: this.map.getSize()});
    this.zoomToExtent(this.marker);
  }

  getNavigation(options: any) {
    const mode = options.mode;
    const feature = options.destination;
    if (mode && feature) {
      this.selectedFeature = feature;
      this.map.removeLayer(this.routesVector);
      this.service.getRouteOpenRoute(
        ol.proj.transform(this.getCoordinates(this.myLocation), 'EPSG:3857', 'EPSG:4326'),
        ol.proj.transform(this.getCoordinates(this.selectedFeature), 'EPSG:3857', 'EPSG:4326'),
        mode).subscribe((response) => {
        const geoJsonObject = new GeoJSON();
        const routes: Feature[] = [];
        geoJsonObject.readFeatures(response).forEach((route: Feature) => {
          const polyline = new ol.geom.LineString(this.getCoordinates(route));
          // Coordinates need to be in the view's projection, which is
          // 'EPSG:3857' if nothing else is configured for your ol.View instance
          polyline.transform('EPSG:4326', 'EPSG:3857');
          const coordinates: Coordinate[] = this.getCoordinates(route).reverse();
          routes[routes.length] = new ol.Feature({
            geometry: polyline,
            duration: StaticMethods.calculateDuration(route.getProperties().summary.duration),
            distance: StaticMethods.calculateDistance(route.getProperties().summary.distance),
            mode,
            durationInMin: route.getProperties().segments[0].duration,
            middlePoint: coordinates[Math.floor(coordinates.length / 2)],
          });
          routes[routes.length - 1].setStyle(this.getRouteStyle(mode, false));
        });
        this.selectFastest(routes);
        this.routesVector = new ol.layer.Vector({
          source: new ol.source.Vector({
            features: routes
          })
        });
        this.map.addLayer(this.routesVector);
        this.zoomToExtent(this.routesVector);
      });
      // this.addRoute();
    }
    // this.addRoute();
  }

  zoomToExtent(vector: Vector) {
    if (vector) {
      const extent = vector.getSource().getExtent();
      this.map.getView().fit(extent, {
        duration: 1000
      });
    } else {
    }
  }

  getRouteStyle(mode: string, selected: boolean) {
    const stylesClass = new MarksStyles();
    switch (mode) {
      case 'driving-car':
        return selected ? stylesClass.selectedCarRoute : stylesClass.carRoute;
      case 'foot-walking':
        return stylesClass.walkingRoute;
    }
  }

  selectFastest(features: Feature[]) {
    let min = null;
    let minFeature = null;
    features.forEach(feature => {
      if (!min) {
        min = feature.getProperties().durationInMin;
        minFeature = feature;
      } else {
        if (feature.getProperties().durationInMin < min) {
          min = feature.getProperties().durationInMin;
          minFeature = feature;
        }
      }
    });
    this.setSelectedRoute(minFeature, features);
  }
}

class MarksStyles {
  public myLocationStyle = new ol.style.Style({
    image: new ol.style.Icon({
      anchor: [0.5, 60],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1,
      scale: 0.5,
      src: 'assets/images/my-location.png'
    })
  });
  public hospitalLocationStyle = new ol.style.Style({
    image: new ol.style.Icon({
      anchor: [0.5, 60],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1,
      scale: 0.5,
      src: 'assets/images/hospital.png'
    })
  });
  public labLocationPin = new ol.style.Style({
    image: new ol.style.Icon({
      anchor: [0.5, 60],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1,
      scale: 0.5,
      src: 'assets/images/lab.png'
    })
  });
  public imagingLocationPin = new ol.style.Style({
    image: new ol.style.Icon({
      anchor: [0.5, 60],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1,
      scale: 0.5,
      src: 'assets/images/imaging.png'
    })
  });
  public randomLocationStyle = new ol.style.Style({
    image: new ol.style.Icon({
      anchor: [0.5, 60],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1,
      scale: 0.5,
      src: 'assets/images/clinic.png'
    })
  });
  public pointStyle = new ol.style.Style({
    image: new ol.style.Circle({
      radius: 5,
      fill: new ol.style.Fill({
        color: '#1B61D5B8'
      }),
      stroke: new ol.style.Stroke({
        color: '#1B61D5'
      })
    })
  });
  public styles = {
    Point: this.randomLocationStyle,
    LineString: new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: 'green',
        width: 1
      })
    }),
    MultiLineString: new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: 'green',
        width: 1
      })
    }),
    MultiPoint: this.randomLocationStyle,
    MultiPolygon: new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: 'yellow',
        width: 1
      }),
      fill: new ol.style.Fill({
        color: 'rgba(255, 255, 0, 0.1)'
      })
    }),
    Polygon: new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: 'blue',
        lineDash: [4],
        width: 3
      }),
      fill: new ol.style.Fill({
        color: 'rgba(0, 0, 255, 0.1)'
      })
    }),
    GeometryCollection: new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: 'magenta',
        width: 2
      }),
      fill: new ol.style.Fill({
        color: 'magenta'
      }),
      image: new CircleStyle({
        radius: 10,
        fill: null,
        stroke: new ol.style.Stroke({
          color: 'magenta'
        })
      })
    }),
    Circle: new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: 'red',
        width: 2
      }),
      fill: new ol.style.Fill({
        color: 'rgba(255,0,0,0.2)'
      })
    })
  };

  selectedCarRoute = new ol.style.Style({
    stroke: new ol.style.Stroke({
      width: 6, color: [24, 170, 13, 0.8]
    })
  });

  carRoute = new ol.style.Style({
    stroke: new ol.style.Stroke({
      width: 6, color: [163, 174, 191, 0.8]
    })
  });

  walkingRoute = new ol.style.Style({
    stroke: new ol.style.Stroke({
      width: 6, color: '#1B61D5B8',
      lineDash: [.1, 10]
    }),
    zIndex: 2
  });

  styleFunction(feature) {
    return this.styles[feature.getGeometry().getType()];
  }
}

export class MovementMethods {
  private finalZoom = 16;

  public setFinalZoom(zoom: number) {
    this.finalZoom = zoom;
  }

  public moveAround(map, location, mode, done) {
    const duration = 1000;
    const zoom = map.getView().getZoom();
    let parts = 2;
    let called = false;

    function callback(complete) {
      --parts;
      if (called) {
        return;
      }
      if (parts === 0 || !complete) {
        called = true;
        done(complete);
      }
    }

    switch (mode) {
      case 'zoom':
        map.getView().animate({
          center: location,
          duration
        }, callback);
        map.getView().animate({
          zoom: this.finalZoom,
          duration
        }, callback);
        break;
      case 'fly':
        map.getView().animate({
          center: location,
          duration
        }, callback);
        map.getView().animate({
          zoom: zoom - 3,
          duration: duration / 2
        }, {
          zoom: this.finalZoom,
          duration: duration / 2
        }, callback);

    }
  }
}
